module.exports = __webpack_public_path__ + "static/media/A6.45ee9acd.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/A6.png
// module id = 872
// module chunks = 0